/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cd_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Countdown Timer`)
};

const es_cd_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Temporizador de Cuenta Atrás`)
};

const de_cd_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Countdown-Timer`)
};

const nl_cd_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aftelklok`)
};

const fr_cd_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compte à Rebours`)
};

const it_cd_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timer per il conto alla rovescia`)
};

const pt_br2_cd_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cronômetro de Contagem Regressiva`)
};

const pt_cd_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Temporizador de Contagem Decrescente`)
};

const ja_cd_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`カウントダウンタイマー`)
};

const zh_cd_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`倒计时器`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cd_h1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cd_h1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cd_h1", locale)
	if (locale === "en") return en_cd_h1(inputs)
	if (locale === "es") return es_cd_h1(inputs)
	if (locale === "de") return de_cd_h1(inputs)
	if (locale === "nl") return nl_cd_h1(inputs)
	if (locale === "fr") return fr_cd_h1(inputs)
	if (locale === "it") return it_cd_h1(inputs)
	if (locale === "pt-BR") return pt_br2_cd_h1(inputs)
	if (locale === "pt") return pt_cd_h1(inputs)
	if (locale === "ja") return ja_cd_h1(inputs)
	return zh_cd_h1(inputs)
};